import {MainRequest} from 'Services/common';

const UrlMap = {
    detail: '/aichat/ragflow',
    edit: '/aichat/ragflow/set',
};

export namespace RagFlow {
    interface Schema {
        name: string; // 名称
        endpoint: string; // 接口地址
        apiKey?: string; // apiKey
        config?: string; // 配置
        status: boolean;
    }

    export interface Detail extends Schema {
        id: string;
    }

    export interface Form extends Schema {
        id?: string;
    }
}

export class RagFlow {
    static async detail() {
        return MainRequest.get<SuccessData<RagFlow.Detail>>(
            `${UrlMap.detail}`,
        ).then(res => res.data.data);
    }

    static async save(data: RagFlow.Form) {
        return MainRequest.post(UrlMap.edit, data);
    }
}
